import { RefObject, useEffect } from 'react'
import { useScroll } from 'react-use'

export default function useScrollToBottom(
  containerRef: RefObject<HTMLDivElement>,
  onBottom: () => void,
) {
  const scroll = useScroll(containerRef)
  useEffect(() => {
    const dom = containerRef.current
    if (dom && (dom.offsetHeight + scroll.y > dom.scrollHeight - 1)) {
      onBottom()
    }
  }, [containerRef, onBottom, scroll])
}